import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  Actividad,
  Aplicacion,
  EntradaCrearAplicacion,
  Escala,
  Version,
} from '@copathy/shared';
import { api } from './api';

/** M6 del lado de la pantalla: el aparato para Copathy y la puerta del trabajador. */

export function useAplicaciones(filtro: { empresaId?: number; cuestionarioId?: number } = {}) {
  const parametros = new URLSearchParams();
  if (filtro.empresaId) parametros.set('empresaId', String(filtro.empresaId));
  if (filtro.cuestionarioId) parametros.set('cuestionarioId', String(filtro.cuestionarioId));

  return useQuery({
    queryKey: ['aplicaciones', filtro.empresaId ?? 0, filtro.cuestionarioId ?? 0],
    queryFn: () => api.get<Aplicacion[]>(`/api/aplicaciones?${parametros.toString()}`),
  });
}

export function useAccionesAplicacion() {
  const qc = useQueryClient();
  const invalidar = () => void qc.invalidateQueries({ queryKey: ['aplicaciones'] });

  const crear = useMutation({
    mutationFn: (datos: EntradaCrearAplicacion) =>
      api.post<Aplicacion>('/api/aplicaciones', datos),
    onSuccess: invalidar,
  });

  const cerrar = useMutation({
    mutationFn: (id: number) => api.post<Aplicacion>(`/api/aplicaciones/${id}/cerrar`),
    onSuccess: invalidar,
  });

  return { crear, cerrar };
}

// ── El lado del trabajador ──

export function useMisActividades() {
  return useQuery({
    queryKey: ['actividades'],
    queryFn: () => api.get<Actividad[]>('/api/actividades'),
  });
}

export function useActividad(id: number) {
  return useQuery({
    queryKey: ['actividades', id],
    queryFn: () =>
      api.get<{ actividad: Actividad; version: Version; escalas: Escala[] }>(
        `/api/actividades/${id}`,
      ),
    enabled: id > 0,
  });
}
